<ng-container *transloco="let t">
    <div class="confirm-dialog" [attr.data-variant]="variant" role="alertdialog" aria-modal="true">
        @if (icon !== 'none') {
            <div class="confirm-dialog__icon" [attr.data-icon]="icon">
                @switch (icon) {
                    @case ('danger') {
                        <!-- Trash glyph for destructive intent -->
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <path
                                fill="currentColor"
                                d="M9 3.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1V4h4a1 1 0 1 1 0 2h-1.07l-.86 13.04A3 3 0 0 1 14.08 22H9.92a3 3 0 0 1-2.99-2.96L6.07 6H5a1 1 0 0 1 0-2h4v-.5Zm2 .5v.5h2V4h-2Zm-2.95 2L8.9 19a1 1 0 0 0 1 .96h4.2a1 1 0 0 0 1-.96L15.95 6h-7.9ZM11 9a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm3 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Z"
                            />
                        </svg>
                    }
                    @case ('info') {
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <path
                                fill="currentColor"
                                d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm-1-9h2v7h-2v-7Zm0-4h2v2h-2V7Z"
                            />
                        </svg>
                    }
                    @default {
                        <!-- Warning triangle -->
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <path
                                fill="currentColor"
                                d="M12.86 2.57a1 1 0 0 0-1.72 0L1.14 19.5A1 1 0 0 0 2 21h20a1 1 0 0 0 .86-1.5L12.86 2.57ZM3.74 19 12 4.96 20.26 19H3.74ZM11 10h2v5h-2v-5Zm0 6h2v2h-2v-2Z"
                            />
                        </svg>
                    }
                }
            </div>
        }

        <div class="confirm-dialog__body">
            <h3 class="confirm-dialog__title">
                {{ text(title, 'common.confirm.title') }}
            </h3>
            <p class="confirm-dialog__message">
                {{ text(message, 'common.confirm.message') }}
            </p>
        </div>

        <div class="confirm-dialog__footer">
            @if (!hideCancel) {
                <button type="button" class="btn" [disabled]="loading()" (click)="cancel()">
                    {{ text(cancelLabel, 'common.cancel') }}
                </button>
            }
            <button
                type="button"
                class="btn confirm-dialog__confirm"
                [class.btn--primary]="variant === 'primary'"
                [class.btn--danger]="variant === 'danger'"
                [class.btn--warning]="variant === 'warning'"
                [disabled]="loading()"
                (click)="confirm()"
            >
                <span
                    *ngIf="pendingAction() === 'confirm'"
                    class="btn__spinner"
                    aria-hidden="true"
                ></span>
                {{ text(confirmLabel, 'common.confirm.confirm') }}
            </button>
            @if (saveAction) {
                <button
                    type="button"
                    class="btn btn--primary confirm-dialog__save"
                    [disabled]="loading()"
                    (click)="save()"
                >
                    <span
                        *ngIf="pendingAction() === 'save'"
                        class="btn__spinner"
                        aria-hidden="true"
                    ></span>
                    {{ text(saveLabel, 'common.save') }}
                </button>
            }
        </div>
    </div>
</ng-container>
